/**
 * @flow
 * @relayHash 936cc8a67ec69785f7e4f3b29de3764f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SaveClipInput = {|
  menuType?: ?string,
  contentType?: ?string,
  contentDetailType?: ?string,
  contentKey: string,
  serviceId: number,
  contentTitle?: ?string,
  contentImageUrl?: ?string,
  clientMutationId?: ?string,
|};
export type SaveClipMutationVariables = {|
  input: SaveClipInput
|};
export type SaveClipMutationResponse = {|
  +saveClip: ?{|
    +data: ?boolean
  |}
|};
export type SaveClipMutation = {|
  variables: SaveClipMutationVariables,
  response: SaveClipMutationResponse,
|};
*/


/*
mutation SaveClipMutation(
  $input: SaveClipInput!
) {
  saveClip(input: $input) {
    data
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SaveClipInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "saveClip",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SaveClipPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "data",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SaveClipMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SaveClipMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "SaveClipMutation",
    "id": null,
    "text": "mutation SaveClipMutation(\n  $input: SaveClipInput!\n) {\n  saveClip(input: $input) {\n    data\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a8bad91ea0eaf7ec9dd069bb9fd8d190';
module.exports = node;
